import React from 'react';
import { ETL_SCHEMAS } from '../../config/etl-schemas';

interface EntitySelectorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function EntitySelector({ value, onChange, disabled = false }: EntitySelectorProps) {
  const entities = Object.values(ETL_SCHEMAS);

  return (
    <div className="entity-grid">
      {entities.map((entity) => {
        const isSelected = value === entity.id;
        return (
          <button
            key={entity.id}
            type="button"
            onClick={() => onChange(entity.id)}
            disabled={disabled}
            className={`entity-card ${isSelected ? 'selected' : ''}`}
          >
            <span className="entity-card-icon">{entity.icon}</span>
            <div className="entity-card-body">
              <p className="entity-card-name">{entity.name}</p>
              <p className="entity-card-desc">{entity.description}</p>
            </div>
            <span className="entity-card-check">✓</span>
          </button>
        );
      })}
    </div>
  );
}